import styled, { css } from 'styled-components';

const TRANSITION_DURATION = '0.3s';

export const viewStyles = {
  blue: {
    blockCSS: css<{ hasError?: boolean; borderColor?: string }>`
      border-radius: 5px;
      height: 38px;
      ${({ hasError, borderColor = '#6a80b8' }) => css`
        border-color: ${hasError ? '#cc0033' : borderColor};
      `}
    `,
    inputCSS: css`
      border-radius: 5px;
      padding-left: 16px;
      font-size: 17px;
      line-height: 19px;
      color: #6a80b8;
    `,
  },
  white: {
    blockCSS: css`
      border-radius: 5px;
      height: 49px;
      box-sizing: border-box;
    `,
    inputCSS: css`
      border-radius: 5px;
      padding-left: 16px;
      color: black;
      font-size: 14px;
      line-height: 14px;
      font-weight: 400;
    `,
  },
  green: {
    blockCSS: css<{ hasError?: string; borderColor?: string }>`
      border-radius: 5px;
      border-width: 2px;
      height: 51px;
      box-sizing: border-box;
      ${({ hasError, borderColor }) => css`
        border-color: ${hasError ? '#cc0033' : borderColor};};
      `}
    `,
    inputCSS: css`
      border-radius: 5px;
      padding-left: 16px;
      color: black;
      font-size: 14px;
      line-height: 14px;
      font-weight: 400;
    `,
  },
};

export const Block = styled.div<{
  viewStyle: keyof typeof viewStyles;
  hasError?: boolean;
  borderColor?: string;
}>`
  display: flex;
  width: 100%;
  border: 1px solid;
  transition: border-color ${TRANSITION_DURATION},
    background-color ${TRANSITION_DURATION};

  ${({ viewStyle, hasError, borderColor = '#ecf2f4' }) => css`
    border-color: ${hasError ? '#cc0033' : borderColor};
    background-color: ${hasError ? '#fce4e4' : 'white'};
    ${viewStyles[viewStyle].blockCSS};
  `}
`;

export const Input = styled.input<{
  viewStyle: keyof typeof viewStyles;
  hasError?: boolean;
  borderColor?: string;
}>`
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: inherit;
  outline: none;
  border: none;

  ${({ viewStyle }) => viewStyles[viewStyle].inputCSS}
`;

export const IconWrapper = styled.div`
  height: 100%;
  width: 50px;
  margin-left: 15px;
  margin-right: 5px;
`;
